import { render, staticRenderFns } from "./DetailTwo.vue?vue&type=template&id=71238eb5&"
import script from "./DetailTwo.vue?vue&type=script&lang=js&"
export * from "./DetailTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71238eb5')) {
      api.createRecord('71238eb5', component.options)
    } else {
      api.reload('71238eb5', component.options)
    }
    module.hot.accept("./DetailTwo.vue?vue&type=template&id=71238eb5&", function () {
      api.rerender('71238eb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/details/DetailTwo.vue"
export default component.exports